import { Grid } from '@mui/material';
import { Fragment, memo } from 'react';
import ForeignStateList from 'shell/components/shared/foreign-state-list';
import { PmiButton } from 'shell/components/shared/button';
import PmiTextField from 'shell/components/shared/text-field';
import { CitizenFormType } from 'subscription/view-models/common-interface-subscription';
import { FormikErrors, FormikTouched } from 'formik';
import PmiDatePicker from 'shell/components/shared/date-picker';

interface FormCitizenshipProps {
  values?: CitizenFormType;
  touched?: FormikTouched<CitizenFormType>;
  errors?: FormikErrors<CitizenFormType>;
  onChange: (key: keyof CitizenFormType, value: CitizenFormType[keyof CitizenFormType]) => void;
  resetForm: () => void;
  disabledState?: boolean;
  disabledDate?: boolean;
  disabledNote?: boolean;
  disabled?: boolean;
  isTransferNew?: boolean;
}

const FormCitizenshipComponent = ({
  values,
  onChange,
  errors,
  touched,
  resetForm,
  disabledState = false,
  disabledDate = false,
  disabled,
  isTransferNew,
}: FormCitizenshipProps): React.ReactElement => {
  return (
    <Fragment>
      <Grid item xs={12} md={6}>
        <ForeignStateList
          value={values?.state?.id ? values.state : null}
          onChange={(state) => {
            onChange('state', state || null);
          }}
          required
          label="Stato"
          id="state-nested-form"
          error={touched?.state && Boolean(errors?.state)}
          disabled={disabledState || disabled}
        />
      </Grid>
      {isTransferNew ? undefined : (
        <Grid item xs={12} md={6}>
          <PmiDatePicker
            label="Data validità *"
            aria-label="Data validità"
            disabled={disabledDate || disabled}
            value={values?.validity || null}
            onChange={(date) => {
              onChange('validity', date);
            }}
            renderInput={(params) => (
              <PmiTextField
                id="date-validity"
                {...params}
                disabled={disabledDate || disabled}
                fullWidth
                error={touched?.validity && Boolean(errors?.validity)}
                helperText={errors?.validity}
              />
            )}
          />
        </Grid>
      )}
      {(disabledDate && disabledState) || (isTransferNew && disabledState) ? undefined : (
        <Grid
          container
          item
          spacing={0}
          rowSpacing={{ xs: 1, md: 0 }}
          columnSpacing={{ xs: 0, md: 1 }}
          xs={12}
        >
          <Grid item xs={12} md={2}>
            <PmiButton
              id="reset-citizenship"
              color="cdmBrandThird"
              variant="outlined"
              fullWidth
              onClick={resetForm}
              disabled={disabled}
            >
              Ripulisci
            </PmiButton>
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
};

FormCitizenshipComponent.displayName = 'Form Citizenship component';

const FormCitizenship = memo(FormCitizenshipComponent);

export default FormCitizenship;
